import { useState } from "react";
import { toast } from "sonner";
import { EMBY_SERVER_ADDRESS } from "@/lib/api";
import { Copy, Check, Smartphone } from "lucide-react";

const STEPS = [
  "Open the official Emby app → choose \"Connect to server manually\".",
  "Enter the server address below (include the /api path).",
  "The app detects a valid Emby server and shows the login screen.",
  "Log in with your Xtream username & password.",
  "Your channels load — press play to stream.",
];

export default function ConnectionInstructions() {
  const [copied, setCopied] = useState(false);

  const copy = () => {
    navigator.clipboard.writeText(EMBY_SERVER_ADDRESS);
    setCopied(true);
    toast.success("Server address copied");
    setTimeout(() => setCopied(false), 1800);
  };

  return (
    <div className="rounded-sm border border-zinc-800 bg-zinc-900 p-6" data-testid="connection-instructions">
      <div className="mb-5 flex items-center gap-2">
        <Smartphone className="h-5 w-5 text-emerald-400" />
        <h2 className="font-heading text-lg font-semibold tracking-tight text-zinc-100">
          Connect your Emby app
        </h2>
      </div>

      <p className="mb-2 font-mono text-xs uppercase tracking-wider text-zinc-500">Server Address</p>
      <div className="mb-6 flex items-stretch gap-2">
        <code
          data-testid="server-address"
          className="flex-1 overflow-x-auto whitespace-nowrap rounded-sm border border-zinc-800 bg-zinc-950 px-3 py-2.5 font-mono text-sm text-emerald-400"
        >
          {EMBY_SERVER_ADDRESS}
        </code>
        <button
          data-testid="copy-address"
          onClick={copy}
          className="flex items-center gap-1.5 rounded-sm border border-zinc-700 bg-zinc-800 px-3 font-mono text-xs uppercase text-zinc-100 transition-colors duration-200 hover:bg-zinc-700"
        >
          {copied ? <Check className="h-4 w-4 text-emerald-400" /> : <Copy className="h-4 w-4" />}
          {copied ? "Done" : "Copy"}
        </button>
      </div>

      <ol className="space-y-3">
        {STEPS.map((s, i) => (
          <li key={i} className="flex gap-3 text-sm text-zinc-400">
            <span className="flex h-5 w-5 flex-none items-center justify-center rounded-sm border border-emerald-500/30 bg-emerald-500/10 font-mono text-xs text-emerald-400">
              {i + 1}
            </span>
            <span>{s}</span>
          </li>
        ))}
      </ol>
    </div>
  );
}
